<footer class="section-footer bg-white border-top">
  <div class="container">
    <section class="footer-main py-5">
      <div class="row">
        <aside class="col-12 col-sm-12 col-lg-4">
          <article class="me-lg-4">
            <img src="../../../assets/camben.png" alt="Logo de CAMBEN, fábrica de uniformes y ropa casual" class="logo-footer">
            <p class="mt-3"> 
              En CAMBEN, somos una **fábrica de ropa en México** especializada en la confección de **uniformes adventistas del Club de Conquistadores Aventureros y Guias Mayores**. Ofrecemos uniformes de alta calidad y también una amplia colección de **ropa casual y juvenil** para que expreses tu estilo.
              <br> © {{ date |date:'yyyy'}} CAMBEN. <br> Todos los derechos reservados. 
            </p>
          </article>
        </aside>

        <aside class="col-6 col-sm-4 col-lg-2">
          <h2 class="title">Enlaces Importantes</h2>
          <ul class="list-menu mb-3">
            <!--li> <a href="/uniformes-adventistas">Uniformes Adventistas</a></li>
            <li> <a href="/ropa-casual">Ropa Casual y Juvenil</a></li-->
            <li> <a routerLink="/TiendaClubAdventista" routerLinkActive="active">Home</a></li>
            <li> <a routerLink="/product" routerLinkActive="active">Tienda de clubes adventistas</a></li>
            <li> <a routerLink="/quienes-somos" routerLinkActive="active">Quiénes Somos</a></li>
            <li> <a routerLink="/encuesta" routerLinkActive="active">Contacto</a></li>
          </ul>
        </aside>

        <aside class="col-6 col-sm-4 col-lg-2">
          <h2 class="title">Servicios</h2>
          <ul class="list-menu mb-3">
            <!--li> <a href="#">Envíos y Entregas</a></li>
            <li> <a href="#">Política de Devoluciones</a></li-->
            <li> <a routerLink="/preguntas-frecuentes" routerLinkActive="active">Preguntas Frecuentes</a></li>
          </ul>
        </aside>

        <aside class="col-6 col-sm-4 col-lg-2">
          <h2 class="title">Contáctanos</h2>
          <ul class="list-menu mb-3">
            <!--li><a href="mailto:tu-correo@camben.com">Email</a></li-->
            <a>Juárez, Nuevo León, México</a>
            <br>
            <a>Teléfono: +528110760979</a>
          </ul>
        </aside>

        <aside class="col-6 col-sm-4 col-lg-2">
          <h2 class="title">Síguenos</h2>
          <div class="social-icons d-flex justify-content-center gap-3">
            <a [href]="facebookUrl" target="_blank" rel="noopener noreferrer" class="social-link">
              <i class="fab fa-facebook-f"></i>
            </a>
            <a [href]="tiktokUrl" target="_blank" rel="noopener noreferrer" class="social-link">
              <i class="fab fa-tiktok"></i>
            </a>
            <a [href]="youtubeUrl" target="_blank" rel="noopener noreferrer" class="social-link">
              <i class="fab fa-youtube"></i>
            </a>
            <!--a href="tu-url-de-instagram" target="_blank" rel="noopener noreferrer" class="social-link">
              <i class="fab fa-instagram"></i>
            </a-->
            <a [href]="linkedinUrl" target="_blank" rel="noopener noreferrer" class="social-link">
              <i class="fab fa-linkedin-in"></i>
            </a>
          </div>
        </aside>
      </div>
    </section>
  </div>
</footer>